module.exports = __webpack_public_path__ + "bda0e1fed82372e027cc5ba1537fcb03.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/pricing/tip.png
// module id = 451
// module chunks = 0